window.organisationForm = {}

window.organisationForm.filterOrganisatie = (data) => {
    while (data.telefoon.match(/[-]/)) {
        data.telefoon = data.telefoon.replace(/[-]/, '');
    }

    while (data.telefoon.match(/[\s]/)) {
        data.telefoon = data.telefoon.replace(/[\s]/, '');
    }

    data.telefoon = data.telefoon.replace('+310', '+31');

    while (data.fax.match(/[-]/)) {
        data.fax = data.fax.replace(/[-]/, '');
    }

    while (data.fax.match(/[\s]/)) {
        data.fax = data.fax.replace(/[\s]/, '');
    }

    data.fax = data.fax.replace('+310', '+31');

    while (data.emailadres.match(/[\s]/)) {
        data.emailadres = data.emailadres.replace(/[\s]/, '');
    }

    data.emailadres = data.emailadres.toLowerCase();

    while (data.website.match(/[\s]/)) {
        data.website = data.website.replace(/[\s]/, '');
    }

    data.website = data.website.toLowerCase();

    while (data.bezoekPostcode.match(/[-]/)) {
        data.bezoekPostcode = data.bezoekPostcode.replace(/[-]/, '');
    }

    while (data.bezoekPostcode.match(/[\s]/)) {
        data.bezoekPostcode = data.bezoekPostcode.replace(/[\s]/, '');
    }

    while (data.postPostcode.match(/[-]/)) {
        data.postPostcode = data.postPostcode.replace(/[-]/, '');
    }

    while (data.postPostcode.match(/[\s]/)) {
        data.postPostcode = data.postPostcode.replace(/[\s]/, '');
    }

    return data;
}

window.organisationForm.validateOrganisatie = (data, asHTMLList = false) => {

    const errors = []

    const addError = (selector, message) => {
        errors.push({
            selector,
            message,
        })
    }

    if (data.naam == '') {
        addError('naam', 'De naam is niet ingevoerd.')
    }

    if (data.telefoon != '') {

        if (!validateTelefoon(data.telefoon)) {
            addError('telefoon', 'Het ingevoerde telefoonnummer is ongeldig.')
        }
    }

    if (data.fax != '') {

        if (!validateTelefoon(data.fax)) {
            addError('fax', 'Het ingevoerde faxnummer is ongeldig.')
        }
    }

    if (data.emailadres != '') {

        if (!validateEmailadres(data.emailadres)) {
            addError('emailadres', 'Het ingevoerde e-mailadres is ongeldig.')
        }
    }

    if (
        !window.organisationForm.bezoekadresPartlyFilled(data)
        && data.postPostcode == ''
        && data.emailadres == ''
        && data.telefoon == ''
    ) {
        addError('postPostcode', 'Er is minimaal 1 adres, emailadres of postcode nodig om de organisatie te kunnen onderscheiden.')
        addError('emailadres', 'Er is minimaal 1 adres, emailadres of postcode nodig om de organisatie te kunnen onderscheiden.')
        addError('telefoon', 'Er is minimaal 1 adres, emailadres of postcode nodig om de organisatie te kunnen onderscheiden.')
    }

    if (window.organisationForm.bezoekadresPartlyFilled(data)) {

        if (data.bezoekLand == 13) {

            if (data.bezoekStraat == '' || data.bezoekNummer == '' || data.bezoekPostcode == '' || data.bezoekPlaats == '') {

                if (data.bezoekStraat == '') {
                    addError('bezoekStraat', 'De straat van het bezoekadres is niet ingevoerd.')
                }
                if (data.bezoekNummer == '') {
                    addError('bezoekNummer', 'Het huisnummer van het bezoekadres is niet ingevoerd.')
                }
                if (data.bezoekPostcode == '') {
                    addError('bezoekPostcode', 'De postcode van het bezoekadres is niet ingevoerd.')
                }
                if (data.bezoekPlaats == '') {
                    addError('bezoekPlaats', 'De plaats van het bezoekadres is niet ingevoerd.')
                }

            }

        } else {

            if (data.bezoekAdres == '') {
                addError('bezoekAdres', 'Het bezoekadres is niet ingevoerd.')
            }
        }
    }

    if (data.bezoekPostcode != '') {

        if (!data.bezoekPostcode.match(/^[1-9][0-9]{3}[A-Za-z]{2}$/i)) {
            addError('bezoekPostcode', 'De ingevoerde postcode is ongeldig.')
        }
    }

    if (data.postStraat != '' || data.postNummer != '' || data.postPostcode != '' || data.postPlaats != '' || data.postAdres != '') {

        if (data.postLand == 13) {

            if (data.postStraat == '' || data.postNummer == '' || data.postPostcode == '' || data.postPlaats == '') {

                if (data.postStraat == '') {
                    addError('postStraat', 'De straat van het postadres is niet ingevoerd.')
                }
                if (data.postNummer == '') {
                    addError('postNummer', 'Het huisnummer van het postadres is niet ingevoerd.')
                }
                if (data.postPostcode == '') {
                    addError('postPostcode', 'De postcode van het postadres is niet ingevoerd.')
                }
                if (data.postPlaats == '') {
                    addError('postPlaats', 'De plaats van het postadres is niet ingevoerd.')
                }
            }

        } else {

            if (data.postAdres == '') {
                addError('postAdres', 'Het postadres is niet ingevoerd.')
            }
        }
    }

    if (data.postPostcode != '') {

        if (!data.postPostcode.match(/^[1-9][0-9]{3}[A-Za-z]{2}$/i)) {
            addError('postPostcode', 'De ingevoerde postcode is ongeldig.')
        }
    }

    if (asHTMLList) {
        if (!errors.length) {
            return ''
        }
        const uniqueErrors = [...new Set(errors.map((error) => error.message))]
        return uniqueErrors.reduce((acc, cur) => {
            acc += '<li>' + cur + '</li>'
            return acc
        }, '<ul>') + '</ul>'
    }

    return errors;
}

window.organisationForm.bezoekadresPartlyFilled = (data) => {
    return data.hasOwnProperty('adresID') || data.bezoekID > 0 || data.bezoekStraat != '' || data.bezoekNummer != '' || data.bezoekPostcode != '' || data.bezoekPlaats != '' || data.bezoekAdres != ''
}
